var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7885EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1128 16.81V19.26H17.4028V20.814H14.1128V23.404H17.8228V25H12.1528V15.214H17.8228V16.81H14.1128ZM27.85 15.228V25H25.89V20.842H21.704V25H19.744V15.228H21.704V19.246H25.89V15.228H27.85Z",
    fill: "#7885EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee6);
export default __webpack_public_path__ + "static/media/employee6.3c7fe6c5f6a4c1c79affa48b30d89c7d.svg";
export { ForwardRef as ReactComponent };